export default function About() {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="py-24 md:py-32 bg-brand-paper"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
                    <div className="lg:col-span-5 relative">
                        <div className="relative">
                            <div className="absolute -top-6 -left-6 w-24 h-24 border border-brand-gold" />
                            <img
                                src="https://images.pexels.com/photos/1181605/pexels-photo-1181605.jpeg?auto=compress&cs=tinysrgb&w=720&h=900"
                                alt="Shameeka Henry & Tiffani Logan, SheFleet Transportation founders"
                                width="720"
                                height="900"
                                loading="lazy"
                                decoding="async"
                                className="relative w-full h-[520px] object-cover"
                            />
                            <div className="absolute -bottom-6 -right-6 w-24 h-24 border border-brand-gold" />
                        </div>
                    </div>

                    <div className="lg:col-span-7">
                        <div className="flex items-center gap-3 mb-6">
                            <span className="w-10 h-px bg-brand-gold" />
                            <span className="text-[10px] tracking-[0.4em] uppercase text-brand-gold-deep">
                                Our Founders
                            </span>
                        </div>

                        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-brand-black leading-tight">
                            Shameeka Henry
                            <span className="text-brand-gold">.</span>
                            <br />
                            Tiffani Logan
                            <span className="text-brand-gold">.</span>
                        </h2>

                        <p className="mt-8 text-lg text-brand-black/75 leading-relaxed">
                            Two women. One vision. A medical courier service that doesn't cut
                            corners and never forgets that behind every package is a patient
                            waiting on the other end.
                        </p>

                        <p className="mt-6 text-base text-brand-black/70 leading-relaxed">
                            Shameeka and Tiffani founded SheFleet Transportation LLC to bring a
                            new standard to medical logistics across the Greater St. Louis area
                            and Southern Illinois — combining the reliability healthcare
                            providers require with the personal touch a locally-owned company
                            can uniquely deliver.
                        </p>

                        <div className="mt-10 grid grid-cols-2 gap-6">
                            <div className="border-l-2 border-brand-gold pl-5">
                                <div className="font-serif text-3xl text-brand-black">Local</div>
                                <div className="text-xs tracking-wider uppercase text-brand-black/60 mt-1">
                                    Rooted in community
                                </div>
                            </div>
                            <div className="border-l-2 border-brand-gold pl-5">
                                <div className="font-serif text-3xl text-brand-black">Trusted</div>
                                <div className="text-xs tracking-wider uppercase text-brand-black/60 mt-1">
                                    Built on integrity
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
